import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'bam-header-search-tab-list',
  styleUrl: 'bam-header-search-tab-list.scss',
})
export class BamHeaderSearchTabList {

  render() {
    return (
      <Host>
        <slot name='headline'></slot>
        <div class='bam-header-search-tab-list__contact'>
          <slot name='hotlinePhone'></slot>
          <slot name='phone'></slot>
        </div>
      </Host>
    )
  }
}
